import { Box, Button, Typography } from '@mui/material';
import React, { ReactNode, useCallback, useMemo, useState } from 'react';
import { classNames } from '../../../utils/classNames';
import { useTranslation } from 'react-i18next';
import { combineToggleStyles } from './style';

interface CombineToggleProps<T extends ToogleOptions> {
  className: string;
  name?: string;
  selectValue: boolean;
  options: T[];
  onChangeHandler: Function;
  title: string;
}

interface ToogleOptions {
  content: string;
  isActive: boolean;
  startIcon?: ReactNode;
  type: 'text';
}

function CombineToggle<T extends ToogleOptions>(props: CombineToggleProps<T>) {
  const { className, name, selectValue, options, onChangeHandler, title } = props;
  const { combineToggle } = combineToggleStyles;
  const [displayValue, setDisplayValue] = useState(selectValue);
  const { t } = useTranslation();

  const handleBtnToggle = (): void => {
    setDisplayValue((prev: boolean) => !prev);
    onChangeHandler();
  };

  const renderTextButton = useCallback(
    (option: any) => (
      <Button
        startIcon={option?.startIcon}
        key={option?.content}
        disableRipple
        variant="text"
        className={classNames('', {
          active: option.isActive,
        })}
        onClick={handleBtnToggle as React.MouseEventHandler<HTMLButtonElement>}
      >
        {t(option.content)}
      </Button>
    ),
    [name, displayValue, t, handleBtnToggle]
  );

  const toggleOptions = useMemo(
    () =>
      options?.map(option => {
        switch (option?.type) {
          case 'text':
            return renderTextButton(option);
        }
      }),
    [options, renderTextButton]
  );

  return (
    <Box sx={{ ...combineToggle }} className={classNames(className)}>
      <Typography>{t(title)}</Typography>
      <Box className="mask-box">
        <Box className={classNames('mask', { right: !displayValue })} />
        {options ? toggleOptions : null}
      </Box>
    </Box>
  );
}

export default CombineToggle;
